import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

export type MainThreadMemory = {
  heapUsedMb: number;
  heapLimitMb: number;
  oldSpaceMb: number;
  largeObjectSpaceMb: number;
  externalMb: number;
  rssMb: number;
};

export type WorkerPoolStats = {
  totalWorkers: number;
  busyWorkers: number;
  idleWorkers: number;
  pendingTasks: number;
  activeTasks: number;
};

export type SystemStats = {
  mainThreadMemory: MainThreadMemory;
  workerPool: WorkerPoolStats;
};

export function getSystemStats(): Promise<SystemStats> {
  return request(`${ROOT_SERVER_URL}/api/system/stats`);
}
